import DataTable from 'components/shared/DataTable/index';
import { getAllProductList } from 'pages/Orders/helpers/call-api';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import FilterModel from './FilterModel';

const ProductModel = ({ open, onClose, onChange, value = [] }) => {
  const [itemSelected, setItemSelected] = useState(value);
  const [loading, setLoading] = useState(null);
  const defaultParams = {
    page: 1,
    itemsPerPage: 6,
  };

  const [data, setData] = useState({
    items: [],
    itemsPerPage: 0,
    page: 0,
    totalItems: 0,
    totalPages: 0,
  });

  const { items = [], itemsPerPage, page, totalItems, totalPages } = data;

  const columns = useMemo(
    () => [
      {
        header: 'Mã sản phẩm',
        accessor: 'product_code',
        classNameHeader: 'bw_sticky bw_name_sticky',
        classNameBody: 'bw_sticky bw_name_sticky',
        formatter: (p) => <b className='bw_sticky bw_name_sticky'>{p?.product_code}</b>,
      },
      {
        header: 'Tên sản phẩm',
        formatter: (p) => <span>{p?.product_name}</span>,
      },
      {
        header: 'Loại',
        classNameHeader: 'bw_text_center',
        classNameBody: 'bw_text_center',
        accessor: 'product_type',
        formatter: (p) => {
          if (p?.product_type === 2) {
            return <span className='bw_label bw_label_success'>Linh kiện</span>;
          } else {
            return <span className='bw_label bw_label_danger'>Sản phẩm</span>;
          }
        },
      },
    ],
    [],
  );

  const loadData = async (newParams = {}) => {
    try {
      setLoading(true);
      const res = await getAllProductList({ ...defaultParams, ...newParams });
      setData(res);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(null);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleSave = () => {
    onChange(itemSelected);
    onClose();
  };

  return (
    <React.Fragment>
      <div className={`bw_modal ${open ? 'bw_modal_open' : ''}`} id='bw_notice_del'>
        <div className='bw_modal_container bw_w800'>
          <div className='bw_title_modal'>
            <h3>Chọn sản phẩm</h3>
            <span className='bw_close_modal fi fi-rr-cross-small' onClick={onClose}></span>
          </div>
          <div className='bw_main_modal bw_border_top'>
            <div className='bw_row'>
              <FilterModel loadData={loadData} />
              <div className='bw_col_12 bw_mt_1' style={{ overflowX: 'auto', maxHeight: '45vh' }}>
                <h3 style={{ marginBottom: 7, fontWeight: 700 }}>Danh sách sản phẩm</h3>
                <DataTable
                  loading={loading}
                  columns={columns}
                  data={items}
                  defaultDataSelect={itemSelected}
                  totalPages={totalPages}
                  itemsPerPage={itemsPerPage}
                  page={page}
                  totalItems={totalItems}
                  fieldCheck='product_id'
                  onChangeSelect={(newSelected) => {
                    setItemSelected(newSelected);
                  }}
                  handleBulkAction={() => setItemSelected([])}
                  onChangePage={(newPage) => loadData({ page: newPage })}
                />
              </div>
            </div>
          </div>
          <div className='bw_footer_modal'>
            <button className='bw_btn bw_btn_success' onClick={handleSave}>
              <span className='fi fi-rr-check'></span>
              Cập nhật
            </button>
            <button onClick={onClose} className='bw_btn_outline bw_btn_outline_danger'>
              Đóng
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ProductModel.propTypes = {
  open: PropTypes.bool,
  className: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.string,
  onClose: PropTypes.func,
  onChange: PropTypes.func,
  children: PropTypes.node,
};

export default ProductModel;
